import { Control, Controller, FieldPath, FieldValues } from "react-hook-form";
import { Slider, SliderProps } from "component-library";

type ControlledSliderProps<F extends FieldValues, N> = {
  control: Control<F>;
  name: N;
} & Omit<SliderProps, "value" | "onChange">;

export const ControlledSlider = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: ControlledSliderProps<TFieldValues, TName>,
) => {
  return (
    <Controller
      name={props.name}
      control={props.control}
      render={({ field }) => (
        <Slider value={field.value} onChange={field.onChange} {...props} />
      )}
    />
  );
};
